import { Component, inject, Input, output } from '@angular/core';

import { MatButton } from '@angular/material/button';
import { notify, SiaTranslatePipe } from '@sia/shared';
import { GoogleAuthService } from '../../services/google-auth.service';
declare var google: any;
@Component({
  selector: 'sia-google-auth-button',
  templateUrl: './sia-google-auth-button.component.html',
  styleUrls: ['./sia-google-auth-button.component.scss'],
  standalone: true,
  imports: [MatButton, SiaTranslatePipe],
})
export class SiaGoogleAuthButtonComponent {
  private googleAuthService = inject(GoogleAuthService);

  @Input() scope?: string =
    'https://www.googleapis.com/auth/userinfo.profile https://mail.google.com/ https://www.googleapis.com/auth/userinfo.email openid email profile';
  @Input() buttonText?: string = 'Accedi con Google';
  @Input() isLogged?: boolean;
  @Input() compact?: boolean;
  @Input() client_id?: string;
  @Input() scopeType?: string;
  @Input() scopeName?: string;
  tokenChanged = output<any>();
  accountChanged = output<any>();

  /** Inserted by Angular inject() migration for backwards compatibility */

  async gAuth() {
    try {
      const res = await this.googleAuthService.login(
        this.scopeType,
        this.scope as string,
        this.scopeName as string,
      );

      if (res.Message) {
        notify(res.Message, 1500, 'error');
        return;
      }
      this.tokenChanged.emit(res);
      this.accountChanged.emit(res.email);
      notify(
        'Login eseguito con successo! Benvenuto ' + res.email,
        3000,
        'success',
      );
    } catch (error: any) {
      notify(
        error?.Message || 'Autenticazione annullata o fallita',
        1500,
        'warning',
      );
    }
  }

  async ngOnInit() {}
  ngOnDestroy() {}
}
